export default __webpack_public_path__ + "static/media/vitebackground.fa3d1ca0.png";